import React from 'react';
import { Preset, Tag, Text } from '@lux/text';
import { FunctionColor } from '@lux/tokens';
import * as S from './styles';
export var Benefit = function (_a) {
    var availability = _a.availability, description = _a.description, image = _a.image, subtitle = _a.subtitle, title = _a.title;
    var icon = availability.icon, text = availability.text;
    return (React.createElement(S.Container, null,
        React.createElement(S.ImageWrapper, { "$backgroundImage": image },
            React.createElement("div", null,
                React.createElement(Text, { bold: true, color: FunctionColor.function0, preset: Preset.L, tag: Tag.DIV }, title),
                React.createElement(Text, { color: FunctionColor.function0, preset: Preset.L, tag: Tag.DIV }, subtitle))),
        React.createElement(S.Description, null,
            React.createElement(Text, { preset: Preset.M }, description)),
        React.createElement(S.Footer, null,
            React.createElement("img", { alt: "", src: icon === null || icon === void 0 ? void 0 : icon.uri }),
            React.createElement(Text, { bold: true, preset: Preset.S }, text))));
};
